/** A frame is black when almost no pixels rise above broadcast-black luma. */
export function frameIsBlack(imageData, {lumaMin = 18, litRatio = 0.02} = {}) {
  const data = imageData?.data
  if (!data || data.length < 4) return true
  const pixels = data.length / 4
  let lit = 0
  for (let i = 0; i < data.length; i += 4) {
    const y = 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2]
    if (y > lumaMin) lit += 1
  }
  return lit / pixels < litRatio
}

/**
 * FIFO queue that runs at most `max` async functions at once.
 * Returns a function that takes an async function and runs it in
 * queue order, returning its promise. Failures free the slot.
 */
export function createQueue(max) {
  let active = 0
  const pending = []

  const drain = () => {
    while (active < max && pending.length > 0) {
      const {fn, resolve, reject} = pending.shift()
      active += 1
      Promise.resolve()
        .then(fn)
        .then(resolve, reject)
        .finally(() => {
          active -= 1
          drain()
        })
    }
  }

  return (fn) =>
    new Promise((resolve, reject) => {
      pending.push({fn, resolve, reject})
      drain()
    })
}

export function sampleTimes(duration, {step = 1 / 24, maxScan = 3} = {}) {
  const end = Math.min(Number.isFinite(duration) && duration > 0 ? duration : maxScan, maxScan)
  const times = []
  for (let t = 0; t <= end + 1e-9; t += step) {
    times.push(Math.min(t, end))
  }
  if (times[times.length - 1] !== end) times.push(end)
  return times
}
